import * as React from 'react';
/**
 *
 * Original name: Dropbox Backup
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=14398%3A91
 *
 */
export const DropboxBackupLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 4c-5.112 0-8 2.888-8 8s2.888 8 8 8v-3.637c-1.377-.003-2.477-.386-3.232-1.144-.757-.76-1.133-1.86-1.133-3.221 0-1.362.382-2.462 1.14-3.22.758-.759 1.856-1.143 3.218-1.143 1.363 0 2.465.386 3.225 1.147.76.759 1.146 1.858 1.147 3.218H20c0-5.112-2.888-8-8-8Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M12.078 11.998V9.104c.92.016 1.608.288 2.07.754.476.481.746 1.204.746 2.167 0 .95-.273 1.665-.75 2.143-.479.478-1.194.751-2.144.751-.95 0-1.667-.267-2.147-.745C9.374 13.697 9.1 12.975 9.1 12h2.98Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
